// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-W":"W_dpu-detail-W__6ssDs"};